import { jsx as e, jsxs as s } from "react/jsx-runtime";
import { aj as V, ak as U, al as x, am as E, an as q, ao as Z, W as w, u as B, ap as z, aq as F, d as P, ar as T, as as y, at as p, au as S, av as G, F as J, B as A, U as H } from "./FormMarkdown-DJdC9HQP.js";
import { aw as se, ax as ae, ay as le, az as ie, aA as ce, aB as de, aC as me, aD as ue, aE as he, aF as ye } from "./FormMarkdown-DJdC9HQP.js";
import { useState as _, useCallback as W, useEffect as R } from "react";
import "./FilterSearch-BR-Q3sXQ.js";
const L = "_form_d5vfq_1", X = {
  form: L
}, Y = (o) => {
  const {
    initialValues: t,
    onSubmit: d,
    validationSchema: l,
    children: a,
    maxWidth: m = "auto",
    context: i
  } = o;
  return /* @__PURE__ */ e(
    V,
    {
      initialValues: t,
      onSubmit: d,
      enableReinitialize: !0,
      validationSchema: l,
      context: i,
      children: (r) => /* @__PURE__ */ e(
        U,
        {
          className: X.form,
          style: { maxWidth: m },
          children: typeof a == "function" ? a(r) : a
        }
      )
    }
  );
}, ee = (o) => {
  const { name: t, children: d } = o, { errors: l } = x(), a = E(l, t);
  return /* @__PURE__ */ s("div", { children: [
    /* @__PURE__ */ e(q, { name: t, children: d }),
    a && typeof a == "string" && /* @__PURE__ */ e(Z, { name: t })
  ] });
}, te = (o) => {
  const {
    name: t,
    image: d,
    aspectRatio: l,
    type: a,
    maxFileSize: m = 10,
    translations: i
  } = o, { setFieldValue: r, values: v, touched: h, setTouched: g } = x(), c = (C) => {
    r(t, C), g({ ...h, [t]: !0 });
  }, f = () => {
    r(t, null), g({ ...h, [t]: !0 });
  };
  return /* @__PURE__ */ e(
    w,
    {
      image: h[t] ? v[t] ? v[t].url : null : d,
      aspectRatio: l,
      type: a,
      maxFileSize: m,
      translations: i,
      onChange: c,
      onRemove: f
    }
  );
}, $ = "_venueSelector_1eh8q_1", u = {
  venueSelector: $
}, j = [
  {
    id: null,
    googleid: "ChIJN-q88npPwUcRQnIMK1bPeis",
    name: "Westerlo",
    terms: ["Westerlo", "Belgium"]
  },
  {
    id: null,
    googleid: "ChIJvXMEhh3Q3YkRrO7B3DkPN58",
    name: "Westerlo",
    terms: ["Westerlo", "Belgium", "Westerlo", "NY", "USA"],
    type: "geocode",
    logo: null,
    verified: !1
  },
  {
    id: null,
    googleid: "ChIJgy8GRJf7tkcRAT4qq1lU3E8",
    name: "Westerstede",
    terms: [
      "Westerlo",
      "Belgium",
      "Westerlo",
      "NY",
      "USA",
      "Westerstede",
      "Westerloy",
      "Germany"
    ]
  },
  {
    id: null,
    googleid: "ChIJSaDKmZ6et0cR8CuA63nPJgo",
    name: "Haselünne",
    terms: [
      "Westerlo",
      "Belgium",
      "Westerlo",
      "NY",
      "USA",
      "Westerstede",
      "Westerloy",
      "Germany",
      "Haselünne",
      "Westerloh",
      "Germany"
    ]
  },
  {
    id: null,
    googleid: "Ei5XZXN0ZXJsb3Nlc3RlZW53ZWcsIEhlaXN0LW9wLWRlbi1CZXJnLCBCZWxnaXVtIi4qLAoUChIJUZ37TfZZwUcRRi6rKk1UObQSFAoSCTna1CjhWcFHEYYBMprsfRr7",
    name: "Westerlosesteenweg",
    terms: [
      "Westerlo",
      "Belgium",
      "Westerlo",
      "NY",
      "USA",
      "Westerstede",
      "Westerloy",
      "Germany",
      "Haselünne",
      "Westerloh",
      "Germany",
      "Westerlosesteenweg",
      "Heist-op-den-Berg",
      "Belgium"
    ]
  }
], D = () => {
  const { apiClient: o } = B(), [t, d] = _([]), l = W(async () => {
    if (o)
      try {
        const r = await (o == null ? void 0 : o.get("/lists/countries"));
        d(r.countries);
      } catch (r) {
        o != null && o.isApiError(r) && console.log(r.response.body);
      }
  }, [o]);
  R(() => {
    l();
  }, [l]);
  const a = {
    location_name: "",
    location_address: "",
    location_zip: "",
    location_city: "",
    location_country: ""
  }, m = z().shape({
    name: F(),
    address: F().required("Please fill in an address"),
    zip: F().required("Please fill in a zip code"),
    city: F().required("Please fill in a city"),
    country: F().required("Please select a country")
  });
  return /* @__PURE__ */ s("div", { children: [
    /* @__PURE__ */ e(P, { variant: "h6", children: "Add a location" }),
    /* @__PURE__ */ s(
      Y,
      {
        initialValues: a,
        validationSchema: m,
        onSubmit: (r) => {
          console.log(r);
        },
        children: [
          /* @__PURE__ */ s(T, { children: [
            /* @__PURE__ */ s(y, { children: [
              /* @__PURE__ */ e(p, { htmlFor: "location_name", children: "Name" }),
              /* @__PURE__ */ e(S, { name: "location_name", type: "text" })
            ] }),
            /* @__PURE__ */ s(y, { children: [
              /* @__PURE__ */ e(p, { htmlFor: "location_address", children: "Address" }),
              /* @__PURE__ */ e(S, { name: "location_address", type: "text" })
            ] }),
            /* @__PURE__ */ s(
              "div",
              {
                style: {
                  display: "grid",
                  gap: "1rem",
                  gridTemplateColumns: "1fr 3fr"
                },
                children: [
                  /* @__PURE__ */ s(y, { children: [
                    /* @__PURE__ */ e(p, { htmlFor: "location_zip", children: "Zip" }),
                    /* @__PURE__ */ e(S, { name: "location_zip", type: "text" })
                  ] }),
                  /* @__PURE__ */ s(y, { children: [
                    /* @__PURE__ */ e(p, { htmlFor: "location_city", children: "City" }),
                    /* @__PURE__ */ e(S, { name: "location_city", type: "text" })
                  ] })
                ]
              }
            ),
            /* @__PURE__ */ s(y, { children: [
              /* @__PURE__ */ e(p, { htmlFor: "location_country", children: "Country" }),
              /* @__PURE__ */ e(
                G,
                {
                  name: "location_country",
                  placeholder: "Select a country",
                  search: !0,
                  options: t.map((r) => ({
                    value: r.code,
                    label: r.name
                  }))
                }
              )
            ] })
          ] }),
          /* @__PURE__ */ s(J, { children: [
            /* @__PURE__ */ e(A, { type: "submit", size: "small", color: "primary", children: "Save" }),
            /* @__PURE__ */ e(A, { size: "small", variant: "link", type: "button", children: "Rather use search" })
          ] })
        ]
      }
    )
  ] });
}, re = (o) => {
  const {
    name: t,
    //disabled,
    venue: d
  } = o, { accountId: l, apiClient: a } = B(), { setFieldValue: m, values: i } = x(), [r, v] = _(""), [h, g] = _([]), [c] = _(d), [f, C] = _(!0), b = W(
    async (n) => {
      !l || !a || console.log(n);
    },
    [l, a]
  );
  R(() => {
    (i[t] && !c || // if the value is set but no venue is selected
    i[t] && c && i[t] !== c.id) && b(i[t]);
  }, [b, t, c, i]);
  const N = W(
    async (n) => {
      !l || !a || !n || g(j);
    },
    [l, a]
  );
  R(() => {
    if (r.length === 0) {
      g([]);
      return;
    }
    const n = setTimeout(() => {
      N(r);
    }, 500);
    return () => clearTimeout(n);
  }, [r, N]), R(() => {
    const n = c ? c.id : null;
    m(t, n);
  }, [t, c, m]);
  const I = W((n) => {
    console.log(n);
  }, []);
  return /* @__PURE__ */ s("div", { className: u.venueSelector, children: [
    f && /* @__PURE__ */ e(D, {}),
    !f && !c && /* @__PURE__ */ s(y, { children: [
      /* @__PURE__ */ e(p, { children: "Label" }),
      /* @__PURE__ */ s("div", { className: u.venueSelector__search, children: [
        /* @__PURE__ */ e(
          H,
          {
            name: t,
            value: r,
            onChange: (n) => {
              v(n);
            },
            placeholder: "Search for a venue",
            clearButton: r.length > 0
          }
        ),
        /* @__PURE__ */ s("ul", { className: u.venueSelector__searchResultsList, children: [
          h.map((n, k) => /* @__PURE__ */ s(
            "li",
            {
              className: u.venueSelector__searchResultsItem,
              tabIndex: 0,
              onClick: () => {
                I(n);
              },
              children: [
                /* @__PURE__ */ e("div", { className: u.searchResult__name, children: n.name }),
                /* @__PURE__ */ e("div", { className: u.searchResult__terms, children: n.terms.join(", ") })
              ]
            },
            `${k}_${n.name}`
          )),
          /* @__PURE__ */ e(
            "li",
            {
              className: u.venueSelector__searchResultsItem,
              children: /* @__PURE__ */ e(
                "button",
                {
                  style: {
                    borderRadius: h.length > 0 ? "0 0 0.5rem 0.5rem" : "0.5rem"
                  },
                  onClick: () => C(!0),
                  children: "Add location"
                }
              )
            }
          )
        ] })
      ] })
    ] })
  ] });
};
export {
  Y as Form,
  ee as FormArray,
  se as FormCheckbox,
  ae as FormColorPicker,
  le as FormDate,
  ie as FormDatePicker,
  Z as FormError,
  T as FormFieldset,
  y as FormGroup,
  ce as FormHelperText,
  S as FormInput,
  p as FormLabel,
  de as FormMarkdown,
  me as FormRadioBar,
  ue as FormRadioGroup,
  G as FormSelect,
  he as FormSlider,
  ye as FormTextArea,
  te as FormUpload,
  re as FormVenueSelector
};
